// extracted by mini-css-extract-plugin
module.exports = {"FAQs":"styles_FAQs__zvyJJ","bg_1":"styles_bg_1__0aZry","height":"styles_height__olKtl"};